// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S4KfI","badges":"styles_badges__1SoJr"};